import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      id: 1,
      icon: 'Shield',
      title: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      id: 2,
      icon: 'Lock',
      title: 'Data Protected',
      description: 'ISO 27001 certified'
    },
    {
      id: 3,
      icon: 'CheckCircle',
      title: 'Verified Platform',
      description: 'Trusted by 50,000+ users'
    }
  ];

  return (
    <div className="mt-8 pt-8 border-t border-border">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {trustBadges?.map((badge) => (
          <div key={badge?.id} className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={badge?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground">{badge?.title}</h4>
              <p className="text-xs text-muted-foreground mt-0.5">{badge?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;